// Map our custom plan IDs ("basic", "premium", etc) to Stripe price IDs
const stripePriceIds = {
  starter: process.env.REACT_APP_STRIPE_PRICE_PRO_STARTER,
  proMonthly: process.env.REACT_APP_STRIPE_PRICE_PRO_MONTHLY,
  proAnnual: process.env.REACT_APP_STRIPE_PRICE_PRO_ANNUAL,
  premierMonthly: process.env.REACT_APP_STRIPE_PRICE_PREMIER_MONTHLY,
  premierAnnual: process.env.REACT_APP_STRIPE_PRICE_PREMIER_ANNUAL,
  collectiveWebsiteMonthly: process.env.REACT_APP_STRIPE_PRICE_COLLECTIVE_WEBSITE_MONTHLY,
  collectiveWebsiteAnnual: process.env.REACT_APP_STRIPE_PRICE_COLLECTIVE_WEBSITE_ANNUAL
};
// Need to update this stripe price ids to correctly get the right plan.. 

// Get Stripe priceId
export function getStripePriceId(planId) {
  return stripePriceIds[planId];
}

// Get friendly plan ID ("basic", "premium", etc) by Stripe plan ID
// Used in auth.js to include planId in the user object
export function getFriendlyPlanId(stripePriceId) {
  return Object.keys(stripePriceIds).find(
    (key) => stripePriceIds[key] === stripePriceId
  );
}
